import { PDF_ENGINE } from 'core/variables/constant';

export type PdfEngine = (typeof PDF_ENGINE)[keyof typeof PDF_ENGINE];

export type PdfEngineFlags = {
  enableNutrient?: boolean;
  enableNutrientStandalone?: boolean;
  enablePdfJs?: boolean;
};

/** Devuelve undefined hasta que cargan los settings, para que el visor no monte con otro motor. */
export function resolvePdfEngine({ enablePdfJs, enableNutrient, enableNutrientStandalone }: PdfEngineFlags): PdfEngine | undefined {
  if (enablePdfJs) return PDF_ENGINE.PDFJS;
  if (enableNutrient === undefined) return undefined;
  if (!enableNutrient) return PDF_ENGINE.PDFTRON;

  return enableNutrientStandalone ? PDF_ENGINE.NUTRIENT_STANDALONE : PDF_ENGINE.NUTRIENT;
}
